import React from "react";
import KidCard from "./KidCard/KidCard";
import {Container, GridList, GridListTile} from "@material-ui/core";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import Boy from './../../assets/static/boy.jpg'
import Girl from './../../assets/static/girl.png'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {

        },
        kidList: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'nowrap',
        },
        gridList: {
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'nowrap',
            // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
            transform: 'translateZ(0)',
        },
        title: {
            color: theme.palette.primary.light,
        },
        titleBar: {
            background:
                'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
        },
    }),
);

const kids = [
    {name: 'Jacek', avatar: Boy, points: 100, active: true},
    {name: 'Agatka', avatar: Girl, points: 100, active: false}
]
const KidList = () => {
    const classes = useStyles();

    return (
        <Container maxWidth="xl">
            <div className={classes.kidList}>
                {/*<GridList className={classes.gridList} cellHeight='auto'>*/}
                    {kids.map((kid: any, index: number) => (
                        // <GridListTile key={kid.name} >
                            <KidCard key={kid.name} kidName={kid.name} avatar={kid.avatar} active={kid.active}/>
                        // </GridListTile>
                    ))}
                {/*</GridList>*/}
            </div>
        </Container>
    )

};

export default KidList;
